import config from 'config';
import { toSlug } from 'utils';
import {localTimeShort} from 'utils/LocalDateTimeHelper';


export function createSportsEvent(props){
  const {
    uri,
    name,
    startDate,
    endDate,
    courseName
    } = props;

  return {
    "@id": uri,
    "@type": "SportsEvent",
    name,
    url: uri,
    startDate,
    endDate,
    location: {
      "@type": "Place",
      "name": courseName,
          "address": {
            "@type": "PostalAddress",
            "addressLocality": courseName
          }
    }
  }
}

export function createSportsEvents(racesToShow = [], courseName = 'unknown', sport, type = 'racecard'){
  if(!sport){
    return [];
  }

  return racesToShow.map(({
          date: dateLong,
          time: time,
          race_summary_reference: {
            id: raceId = ''
          } = {},
          name
        } = {}
  ) => {
    let raceName = '';
    let event_time = `${localTimeShort(`${dateLong}T${time}Z`)}`;
    if(sport === 'greyhounds'){
      name = `${event_time} ${courseName}`
    }
    else{
      raceName = `/${toSlug(name)}`
    }

    let eventURI = '';
    if(type === 'racecard'){
      eventURI = `${config.canonicalBase}/${sport}/racecards/${dateLong}/${toSlug(courseName)}/racecard/${raceId}${raceName}`;
    }
    else{
      eventURI = `${config.canonicalBase}/${sport}/results/${dateLong}/${toSlug(courseName)}/${raceId}${raceName}`;
    }

    const startDate = `${dateLong}T${time}Z`;

    return createSportsEvent({ uri:eventURI, name, startDate, endDate:startDate, courseName});
  });

}



// WEBPACK FOOTER //
// ./modules/Common/components/JSONLDSportsEvent.js